import React, {useEffect} from 'react';
import { Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/store';
import TagChip from './TagChip';

function formatTime(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();

    if (isToday) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' }) +
        ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

/**
 * ChatMessage — renders a single chat message bubble with author info and tags.
 *
 * Props:
 *   message  object from API/WebSocket
 *   clubGuid string — used for navigation when a tag is clicked
 */
export default function ChatMessage({ message, clubGuid }) {
    const navigate = useNavigate();
    const currentUserGuid = useAuthStore((s) => s.user?.guid);

    const isOwn = message.user?.guid === currentUserGuid;
    const isPodcaster = message.user?.type === 'podcaster';

    useEffect(() => {
        console.log('chat message msg- ', message)
        console.log('chat message cguid - ', clubGuid)
    }, []);

    const handleTagClick = (type, guid) => {
        switch (type) {
            case 'episode':
                // Navigate to the episode within this club (use pivot guid)
                navigate(`/listener-episode/${clubGuid}/${guid}`);
                break;
            case 'key_takeaway':
                // Takeaways live inside an episode page; navigate to club for now
                navigate(`/listener-podcast-club/${clubGuid}`);
                break;
            case 'practice':
                navigate(`/listener-podcast-club/${clubGuid}`);
                break;
            default:
                break;
        }
    };

    return (
        <div className={`chat-message ${isOwn ? 'chat-message--own' : 'chat-message--other'}`}>
            {!isOwn && (
                <div className="chat-message__avatar">
                    {message.user?.avatar_url ? (
                        <img src={message.user.avatar_url} alt={message.user.first_name} />
                    ) : (
                        <span>{(message.user?.first_name ?? '?')[0].toUpperCase()}</span>
                    )}
                </div>
            )}

            <div className="chat-message__body">
                {!isOwn && (
                    <div className="chat-message__meta">
                        <span className="chat-message__name">
                            {message.user?.first_name} {message.user?.last_name}
                        </span>
                        {isPodcaster && (
                            <Badge bg="primary" className="chat-message__badge">
                                Podcaster
                            </Badge>
                        )}
                    </div>
                )}

                <div className="chat-message__bubble">
                    <p className="chat-message__text">{message.message}</p>

                    {message.tags && message.tags.length > 0 && (
                        <div className="chat-message__tags">
                            {message.tags.map((tag, idx) => (
                                <TagChip
                                    key={idx}
                                    type={tag.taggable_type}
                                    displayText={tag.display_text}
                                    guid={tag.taggable_guid}
                                    onClick={handleTagClick}
                                />
                            ))}
                        </div>
                    )}
                </div>

                <span className="chat-message__time">{formatTime(message.created_at)}</span>
            </div>
        </div>
    );
}
